module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-bouquet-b11b8f8fde612c268c7d6f378e58d2b6.png";